(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tavern-chronicles"] && !Shopify.designMode) return;
  try {
    
  const initTavernChroniclesScroll = (root) => {
    if (!root) return;

    // Keep carousel scrollable via arrows / native horizontal gestures only.
    // Do not convert vertical wheel to horizontal — that blocks page scroll on hover.
    root.querySelectorAll('.resource-list__carousel slideshow-component').forEach((slideshow) => {
      slideshow.setAttribute('in-viewport', '');
    });
  };

  initTavernChroniclesScroll(document.querySelector('.tavern-chronicles'));

  document.addEventListener('shopify:section:load', (event) => {
    initTavernChroniclesScroll(event.target.querySelector('.tavern-chronicles'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tavern-reviews"] && !Shopify.designMode) return;
  try {
    
  const upgradeTavernReviewImages = (widget) => {
    widget.querySelectorAll('.jdgm-carousel-item__product-image').forEach((img) => {
      ['src', 'data-src', 'data-src-retina'].forEach((attr) => {
        const value = img.getAttribute(attr);

        if (value && /_\d+x\d+/.test(value)) {
          img.setAttribute(attr, value.replace(/_\d+x\d+/, '_360x360'));
        }
      });

      const dataSrc = img.getAttribute('data-src');

      if (dataSrc) {
        img.src = dataSrc;
      }
    });
  };

  const initTavernReviewsWidget = (widget) => {
    if (!widget || widget.dataset.tavernReviewsReady === 'true') {
      return;
    }

    widget.dataset.tavernReviewsReady = 'true';
    upgradeTavernReviewImages(widget);

    const observer = new MutationObserver(() => {
      upgradeTavernReviewImages(widget);
    });

    observer.observe(widget, { childList: true, subtree: true });
  };

  document.querySelectorAll('[data-tavern-reviews-widget]').forEach(initTavernReviewsWidget);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-tavern-reviews-widget]').forEach(initTavernReviewsWidget);
  });

  } catch(e) { console.error(e); }
})();
})();
